import { Component, OnInit } from "@angular/core";
import { HttpErrorResponse } from "@angular/common/http";
import {
  SedsLoadersCoreModeOptions,
  SedsSizeOptions,
} from "@serasa/shared/seds"; // NOSONAR
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";

import { AnalyticsService } from "@serasa/shared/services/analytics.service";
import { SidenavManagerService } from "@serasa/shared/services/sidenav.manager.service";
import { SiteSection } from "@serasa/shared/enums/site-section.enum";
import { Utils } from "@serasa/shared/utils/utils";
import { User } from "../../interfaces/user.interface";
import { closeSideNav } from "../../state/actions/user.actions";
import { selectError, selectLogon, selectUserMeInfo } from "../../state/selectors/user.selectors";
import { UserMe } from "@serasa/core/modules/recertification/interfaces/user-me.interface";
import { canEditAccount } from "@serasa/shared/utils/account-guardrails.util";
import { Logon } from "../../interfaces/logon.interface";

type Error = HttpErrorResponse | null | undefined;
@Component({
    selector: "pl-user-details",
    templateUrl: "./user-details.component.html",
    styleUrls: ["./user-details.component.scss"],
    standalone: false
})
export class UserDetailsComponent implements OnInit {
  public smallButton = SedsSizeOptions.SMALL;
  public mode = SedsLoadersCoreModeOptions;

  public details$?: Observable<any>;
  public error$?: Observable<Error>;
  public userMeInfo$!: Observable<UserMe | null | undefined>;

  constructor(
    public sidenavManagerService: SidenavManagerService,
    private readonly _analyticsService: AnalyticsService,
    private readonly store: Store,
  ) {}

  ngOnInit(): void {
    this.error$ = this.store.select(selectError);
    this.details$ = this.store.select(selectLogon);
    this._analyticsService.doPageLoad(SiteSection.DETALHES_USUARIO);
    this.userMeInfo$ = this.store.select(selectUserMeInfo);
  }

  public edit() {
    this.sidenavManagerService.navigate$.next("edit");
  }

  public isManagerUser(user: string): boolean {
    const userLogon = Utils.decodeToken(Utils.getCookie("accessToken"));
    return userLogon?.logon === user;
  }

  public closeSideNav() {
    this.store.dispatch(closeSideNav());
  }

  public canUserSeeUnblockedOption(user: User): boolean {
    return Utils.canUserSeeUnblockedOption(user);
  }

  public canEditAccount(logon?: Logon | User | null): boolean {
    return canEditAccount(logon);
  }
}
